// 권위: dashboard-api SectorInsightsController (작업 중)
//   GET /api/v1/sector-insights
//   GET /api/v1/sector-insights/{canonical_key}/stocks?page=&size=
//   GET /api/v1/sector-insights/{canonical_key}/sources
//
// envelope 언랩은 apiClient interceptor 가 처리 (data 만 도달).

export interface SectorInsightsSourceRef {
  source: string;
  sector_name: string;
}

export interface SectorInsightsListItem {
  canonical_key: string;
  canonical_display_name: string;
  source_sector_count: number;
  stock_count: number;
  total_market_cap: number;
  source_sectors: SectorInsightsSourceRef[];
}

export interface SectorInsightsListResponse {
  trading_date: string | null;
  items: SectorInsightsListItem[];
}

export interface SectorInsightsStockSourceRef {
  source: string;
  source_sector_name: string;
}

export interface SectorInsightsStockItem {
  symbol: string;
  name: string;
  stock_score: number | null;
  market_cap: number;
  sources: SectorInsightsStockSourceRef[];
}

export interface SectorInsightsStocksResponse {
  canonical_key: string;
  canonical_display_name: string;
  trading_date: string | null;
  page: number;
  size: number;
  total_count: number;
  items: SectorInsightsStockItem[];
}

export interface SectorInsightsSourceItem {
  source: string;
  source_sector_name: string;
  stock_count: number;
  total_market_cap: number;
  total_stock_score: number;
}

export interface SectorInsightsSourcesResponse {
  canonical_key: string;
  canonical_display_name: string;
  trading_date: string | null;
  sources: SectorInsightsSourceItem[];
}

export type SectorInsightsTabId = 'stocks' | 'sources';
export const DEFAULT_INSIGHTS_TAB: SectorInsightsTabId = 'stocks';
export const STOCKS_PAGE_SIZE = 50;
